import { RouterProvider } from "react-router-dom";
import { router } from "./routes/router";
import { ConfigProvider } from "antd";
import viVN from "antd/locale/vi_VN";
import enUS from "antd/locale/en_US";
import dayjs from "dayjs";
import "dayjs/locale/vi";
import "dayjs/locale/en";
import moment from "moment";
import "moment/locale/vi";
import { useTranslation } from "react-i18next";
import { DirtyProvider } from "./contexts/DirtyProvider";
import katex from "katex";
import "katex/dist/katex.min.css";
import WebSocketComponent from "./components/websocket/WebSocketComponent";
import { useEffect, useState } from "react";
import { getPermission } from "./service/common";
import { globalStore, useAuthStore } from "./stores/stores";
// @ts-ignore */
window.katex = katex;

function App() {
  const { setPersonalInfo, reloadAdminInterface } = globalStore();
  const accessToken = useAuthStore((state) => state.accessToken);
  const { i18n } = useTranslation();
  const [currentLocale, setCurrentLocale] = useState(i18n.language?.startsWith("en") ? enUS : viVN);

  useEffect(() => {
    window.document.title = `${process.env.REACT_APP_PROJECT_NAME || ""}`;
  }, []);

  useEffect(() => {
    const isEn = i18n.language?.startsWith("en");
    setCurrentLocale(isEn ? enUS : viVN);
    dayjs.locale(isEn ? "en" : "vi");
    moment.locale(isEn ? "en" : "vi");

    const handleLanguageChanged = (lng: string) => {
      const en = lng?.startsWith("en");
      setCurrentLocale(en ? enUS : viVN);
      dayjs.locale(en ? "en" : "vi");
      moment.locale(en ? "en" : "vi");
    };

    i18n.on("languageChanged", handleLanguageChanged);
    return () => {
      i18n.off("languageChanged", handleLanguageChanged);
    };
  }, [i18n]);

  useEffect(() => {
    if (accessToken) {
      const getPersonalInfo = async () => {
        await getPermission().then((res) => {
          if (res.status === 200) {
            setPersonalInfo(res.data?.data);
          }
        });
      };
      getPersonalInfo();
    }
  }, [reloadAdminInterface, accessToken]);

  return (
    <>
      <ConfigProvider
        locale={currentLocale}
        theme={{
          token: {
            fontFamily: "Roboto",
          },
        }}
      >
        <DirtyProvider>
          <WebSocketComponent>
            <RouterProvider router={router} />
          </WebSocketComponent>
        </DirtyProvider>
      </ConfigProvider>
    </>
  );
}

export default App;
